import { Input } from 'tea-component';
import React, { useEffect, useState } from 'react';

export function NumberInput(props: { className: string; between: boolean; numberValues: any[]; onChange: Function; isEn: boolean; }) {
  const { className, between, numberValues, onChange, isEn } = props;
  const defaultValues =
    numberValues.length === 0 ? ['', ''] : numberValues.length === 1 ? [numberValues[0], ''] : numberValues;
  const [values, setValues] = useState(defaultValues);

  useEffect(() => {
    onChange(values);
  }, [JSON.stringify(values)]);

  return (
    <div className={className}>
      <Input
        type="number"
        size="s"
        placeholder={isEn ? "Enter numeric value" : "输入数值"}
        autoComplete="off"
        value={values?.[0]}
        onChange={(value, context) => {
          setValues([value, values?.[1]]);
        }}
      />
      {between === true ? (
        <>
          <span style={{ margin: '0px 5px' }}>-</span>
          <Input
            type="number"
            size="s"
            placeholder={isEn ? "Enter numeric value" : "输入数值"}
            autoComplete="off"
            value={values?.[1]}
            onChange={(value, context) => {
              setValues([values?.[0], value]);
            }}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
